import React from 'react';
import PropTypes from 'prop-types';

const ToastTable = ({ data, onClose, title }) => {
  return (
    <>
      <div className='toast-table top-50 start-50 translate-middle'>
        <div className='overflow-auto h-320'>
          <table className='table border mb-0'>
            <thead>
              <tr>
                <th>{title}</th>
                <th>Students Assigned</th>
                <th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={`assign${index}`}>
                  <td>{item.assignmentName}</td>
                  <td>{item.studentsAssigned}</td>
                  <td>{item.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <button className="btn btn-castleRed mt-3" onClick={onClose}>
          OK
        </button>
      </div>
      <div className='modal-overlay'>
      </div>
    </>
  );
};

ToastTable.propTypes = {
  data: PropTypes.array,
  onClose: PropTypes.func,
  title: PropTypes.string
};

export default ToastTable;
